import React from 'react';
import { Card, Image, Transition } from 'semantic-ui-react';

import Base from './Base';
import defaultAvatar from 'src/assets/default_profile.jpeg';

type Props = {
  user?: Model.User;
};

export default class Member extends Base<Props> {
  render() {
    const { onClick, user } = this.props;

    return (
      <Transition animation="fade down" transitionOnMount duration={500}>
        <Card fluid onClick={onClick}>
          <div className="d-flex d-column justify-between align-center">
            <Image
              circular
              width={180}
              height={180}
              src={user?.profile_picture || defaultAvatar}
              className="mb-36 object-fit-cover"
            />
          </div>
          {this.renderBase({
            labelCls: 'text-center',
            headerCls: 'text-center fw-normal',
          })}
        </Card>
      </Transition>
    );
  }
}
